<template>
    <div class="w-full py-4">
        Usuários
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Users',
    data() {
        return {
            firstName: '',
            lastName: '',
            password: '',
            passwordConfirm: '',
            email: ''
        };
    },
    computed: {
        ...mapGetters('auth', ['loggedIn'])
    },
    methods: {}
};
</script>

<style></style>
